export default __webpack_public_path__ + "static/media/Hop_dark.423942af.svg";